"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function () {
    return (0, styles_1.createStyles)({
        container: material_kit_pro_react_1.container
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map